var _path, _path2, _rect, _rect2, _rect3, _rect4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFindOutMore4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "141 325 878.7 240.9",
    style: {
      enableBackground: "new 141 325 878.7 240.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1011.3,333.4c-5.6-5.6-12.1-8.4-19.5-8.4H675.5c-7.4,0-14,2.8-19.5,8.4c-5.6,5.6-8.4,12.1-8.4,19.5V538 c0,7.4,2.8,14,8.4,19.5c5.6,5.6,12.1,8.4,19.5,8.4h316.3c7.4,0,14-2.8,19.5-8.4c5.6-5.6,8.4-12.1,8.4-19.5V352.9 C1019.7,345.5,1016.9,338.9,1011.3,333.4z M974.3,538.1c0,6.6-5.4,12-12,12H705c-6.6,0-12-5.4-12-12V353c0-6.6,5.4-12,12-12h257.3 c6.6,0,12,5.4,12,12V538.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M504.8,333.3c-5.6-5.6-12.1-8.4-19.5-8.4H168.9c-7.4,0-14,2.8-19.5,8.4c-5.6,5.6-8.4,12.1-8.4,19.5V538 c0,7.4,2.8,14,8.4,19.5c5.6,5.6,12.1,8.4,19.5,8.4h316.3c7.4,0,14-2.8,19.5-8.4c5.6-5.6,8.4-12.1,8.4-19.5V352.9 C513.1,345.4,510.4,338.9,504.8,333.3z M497.2,538c0,6.6-5.4,12-12,12H169c-6.6,0-12-5.4-12-12V352.9c0-6.6,5.4-12,12-12h316.1 c6.6,0,12,5.4,12,12V538z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 208.5,
    y: 407.3,
    width: 237.2,
    height: 18.3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 208.5,
    y: 464.8,
    width: 237.2,
    height: 18.3
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 738.1,
    y: 407.6,
    width: 191.1,
    height: 18.3
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 738.1,
    y: 465.1,
    width: 191.1,
    height: 18.3
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFindOutMore4);
export default __webpack_public_path__ + "static/media/findOutMore4.6925fae163d3aae8ed5b553748b6009b.svg";
export { ForwardRef as ReactComponent };